/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const shield_lock_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3 4.91v6.979c0 4.516 2.781 8.566 6.996 10.187l.954.366a2.75 2.75 0 0 0 1.975 0l.954-.366a10.915 10.915 0 0 0 6.996-10.187v-6.98a1.363 1.363 0 0 0-.796-1.248A19.892 19.892 0 0 0 11.937 2c-2.8-.026-5.574.54-8.141 1.66-.488.223-.8.712-.796 1.248Z"
      clipRule="evenodd"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.813 11.75a1.5 1.5 0 0 1 1.5-1.5h5.25a1.5 1.5 0 0 1 1.5 1.5v3.876a1.5 1.5 0 0 1-1.5 1.5h-5.25a1.5 1.5 0 0 1-1.5-1.5V11.75Z"
      clipRule="evenodd"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.938 6.126a2.75 2.75 0 0 0-2.75 2.75v1.375h5.5V8.876a2.75 2.75 0 0 0-2.75-2.75Z"
      clipRule="evenodd"
    />
  </svg>
)
export default shield_lock_medium
